module.exports = "<p>\n  internal-grid works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/issues/internal/internal-grid/internal-grid.component.html
// module id = ./src/app/issues/internal/internal-grid/internal-grid.component.html
// module chunks = main